import { getProductCategoryUrl } from 'lib/category'
import { slugifyTitle } from 'lib/slugify'

const getArtworkLinks = (data): Record<string, any> => {
  const {
    artwork_title: artworkTitle,
    legacy_art_id: legacyArtId,
    artId,
    category,
    id_user: idUser,
    original_status: originalStatus,
    prints_availability: printsAvailability,
  } = data || {}
  const hasPrints = printsAvailability !== 'none'
  const title = slugifyTitle(`${getProductCategoryUrl(category)}-${artworkTitle}`)
  const path = `${title}/${idUser}/${legacyArtId || artId}`
  const originalUrl = `/art/${path}/view`
  const printUrl = `/print/${path}/view`
  let productUrl = originalUrl

  if (hasPrints && originalStatus === 'unavail') {
    productUrl = printUrl
  }

  return {
    originalUrl,
    printUrl,
    productUrl,
  }
}

export function whitelistAlgoliaArtworkData(data: Record<string, any>): Record<string, any> {
  const artistName =
    data.first_name && data.first_name ? `${data.first_name} ${data.last_name}` : ''
  const { originalUrl, printUrl, productUrl } = getArtworkLinks(data)
  return {
    api: 'algolia',
    artistId: data.id_user,
    artistName,
    artworkId: data.artId,
    category: data.category,
    baseImageUrl: data.image_url.replace(/-[\d].jpg$/, ''),
    // strip `-6.jpg`
    country: data.country,
    dimensions: {
      width: data.width,
      height: data.height,
      depth: data.depth,
    },
    minPrintPrice: Number(data.min_print_price) || '',
    originalStatus: data.original_status,
    price: Number(data.price) || '',
    printsAvailability: data.prints_availability,
    productPage: !data.price && data.has_prints ? printUrl : originalUrl,
    hasOpenEditions: !!data.has_prints,
    originalListPrices: data.geo_prices || {},
    productUrl,
    profileUrl: data.profile_url,
    sku: data.sku,
    subject: data.subject,
    styles: data.styles,
    mediums: data.mediums,
    materials: data.materials,
    title: data.artwork_title,
  }
}
export function whitelistVisiiArtworkData(results: Record<string, any>): Record<string, any> {
  const { metadata } = results
  // Split product page url
  // Uses /artdetail (or /art) or /print as the base path later on
  // TODO: setup /artdetail and /print paths
  // to re-render components with Next router
  const productPath = metadata.product_page.split('/art/')[1]
  const isOriginalArtwork = metadata.sku.startsWith('P1-')
  const productPage = `/${isOriginalArtwork ? 'art' : 'print'}/${productPath}`
  const originalListPrices = Object.keys(metadata).reduce((acc, key) => {
    if (key.startsWith('price_')) {
      const destinationZone = key.substring(6)
      acc[destinationZone.toUpperCase()] = metadata[key] * 100
    }

    return acc
  }, {})

  const stylesString = typeof metadata.style === 'string' ? metadata.style : ''

  return {
    api: 'visii',
    artistName: metadata.artist_name,
    artworkId: Number(metadata.artwork_id),
    artworksUrl: metadata.artwork_url,
    aspectRatio: metadata.width / metadata.height || 1,
    baseImageUrl: metadata.image_url.replace(/-[\d].jpg$/, ''),
    // strip `-6.jpg`
    category: metadata.category,
    dimensions: {
      width: metadata.width,
      height: metadata.height,
      depth: metadata.depth,
    },
    imageUrl: metadata.image_url,
    isSeoValid: true,
    // Vissi Artwork is VALID
    minPrintPrice: metadata.starting_print_price ? metadata.starting_print_price * 100 : '',
    hasOpenEditions: metadata.starting_print_price > 0,
    originalStatus: 'avail',
    price: '',
    originalListPrices,
    productUrl: productPage,
    productPage,
    productPath,
    profileUrl: metadata.artist_url,
    sku: metadata.sku,
    styles: stylesString === '' ? [] : stylesString.split(','),
    subject: metadata.subject,
    title: metadata.title,
  }
}
